import {parse as parseDate} from 'date-fns';
import {parse as xmlParse, j2xParser} from 'fast-xml-parser';

import {
    generalInfoPageValues,
    documnetPageValues,
} from 'models/documents/invoices/create/defaultVariables';

import {InfoValues, InvoiceLine, PageValues, TaxesFullObj} from 'types/invoices';

import {setTestingXml} from './xmlBuilder';
import {parseXmlToData} from './xmlToDataCompiler';

export function formatDateToDDMMYYYY(dateString: Date | string | undefined) {
    if (!dateString) {
        return;
    }
    const date = new Date(dateString);

    const day = date
        .getDate()
        .toString()
        .padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    return `${year}-${month}-${day}`;
}

function formatDate(x: Record<string, any>) {
    const DATES = [
        'issueDate',
        'dueDate',
        'periodFrom',
        'periodTo',
        'taxPointDate',
        'paymentDueDate',
    ];

    return Object.entries(x).reduce((total, [key, value]) => {
        if (DATES.find((i) => i === key)) {
            return {...total, [key]: formatDateToDDMMYYYY(value)};
        }
        return {...total, [key]: value};
    }, {});
}

export enum InvoiceKeys {
    generalInfo = 'GeneralInformation',
    relatedDocs = 'RelatedDocuments',
    invoiceLines = 'InvoiceLines',
    taxes = 'Taxes',
}
const optionsForBuilder = {
    ignoreAttributes: false,
    format: true,
    indentBy: '  ',
};

export const setXmlFile = (arr: any) => {
    const [GeneralInformation, RelatedDocuments, ItemChargeIndicator, InvoiceLines, Taxes] = arr;

    const newTestPeppolXml = setTestingXml(
        GeneralInformation,
        RelatedDocuments,
        Taxes.data,
        InvoiceLines,
    );
    // eslint-disable-next-line new-cap
    const builder = new j2xParser(optionsForBuilder);
    const cleanedTestXml = cleanEmpty(newTestPeppolXml);
    const xmlDataStr = builder.parse(cleanedTestXml);
    return xmlDataStr;
};

function cleanEmpty(obj: any): any {
    if (obj === null || obj === undefined || obj === '') return undefined;
    if (typeof obj === 'object') {
        if (Array.isArray(obj)) {
            const cleaned = obj.map(cleanEmpty).filter((x) => x !== undefined);
            return cleaned.length > 0 ? cleaned : undefined;
        }
        const cleaned: any = {};
        for (const key in obj) {
            if (key) {
                const val = cleanEmpty(obj[key]);
                if (val !== undefined) cleaned[key] = val;
            }
        }
        return Object.keys(cleaned).length > 0 ? cleaned : undefined;
    }
    return obj;
}

// interface ParsedDataInterface {
//     invoice: {
//         generalInformation: InfoValues;
//         relatedDocuments: PageValues;
//         invoiceLines: InvoiceLine[];
//         taxes: TaxesFullObj;
//     };
// }
export const doParseXml = (xml: string) => {
    const invoice = parseXmlToData(xml);
    return {
        invoice: {
            generalInformation: {
                ...generalInfoPageValues,
                ...invoice.infoValues,
            },
            relatedDocuments: {
                ...documnetPageValues,
                ...invoice.pageValues,
            },
            invoiceLines: {...invoice.invoiceLine},
            taxes: {
                data: {
                    ...invoice.taxesAndTotal,
                },
                allowToSend: false,
            },
        },
    };
};
